import { render, staticRenderFns } from "./FormRaporttiAsetuksetKTLRaportti.vue?vue&type=template&id=30c224f6&"
import script from "./FormRaporttiAsetuksetKTLRaportti.vue?vue&type=script&lang=js&"
export * from "./FormRaporttiAsetuksetKTLRaportti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30c224f6')) {
      api.createRecord('30c224f6', component.options)
    } else {
      api.reload('30c224f6', component.options)
    }
    module.hot.accept("./FormRaporttiAsetuksetKTLRaportti.vue?vue&type=template&id=30c224f6&", function () {
      api.rerender('30c224f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormRaporttiAsetuksetKTLRaportti.vue"
export default component.exports